import React from "react"
import Period from "../period"
import { formGroup } from "./formGroup"
import { InputError } from "./inputError";

import { registerLocale } from "react-datepicker";
const it = require('date-fns/locale/it')
registerLocale('it', it)
import Datepicker from "react-datepicker";

export interface DateTimePickerProps {
    value?: Date;
    onSelectDate: (date: Date | null) => void;
    dateRange?: Period;
    readOnly?: boolean;
    required?: boolean;
    enableDates?: Date[];
    label?: string;
    error?: string;
    onCalendarClose?(): void;
}

export class DateTimePicker extends React.Component<DateTimePickerProps>{

    render() {
        const { label, value, readOnly,
            enableDates, dateRange,
            required, error } = this.props;
        return (
            <>
                {label != null ? <label className="form-label">{label}</label> : null}
                <Datepicker
                    showTimeSelect
                    onChange={this.props.onSelectDate}
                    className="form-control"
                    disabled={readOnly}
                    required={required}
                    startDate={dateRange?.from}
                    endDate={dateRange?.to}
                    includeDates={enableDates}
                    selected={value && !isNaN(value.valueOf()) ? value : null}
                    locale="it"
                    dateFormat="dd/MM/yyyy HH:mm"
                    closeOnScroll
                    onCalendarClose={this.props.onCalendarClose}
                />
                <InputError error={error} />
            </>
        );
    }
}

export const DateTimePickerForms = formGroup(DateTimePicker);